import localforage from 'localforage'
import * as API from '~/api'

export const state = () => ({
  passes: [],
  sync: {
    running: false,
    progress: null,
    date: null,
    error: false
  },
  hydrated: false
})

export const mutations = {
  setSync (state, { running, progress, date, error = null }) {
    if (!(running === undefined)) {
      state.sync.running = running
    }
    if (!(progress === undefined)) {
      state.sync.progress = progress
    }
    if (!(date === undefined)) {
      state.sync.date = date
    }

    state.sync.error = error
  },
  updatePasses (state, passes) {
    state.passes = Object.freeze(API.Pass.ensure(passes))
  },
  setHydrated (state, hydrated) {
    state.hydrated = hydrated
  }
}

export const getters = {
  isSyncing (state) {
    return state.sync.running
  },
  syncProgress (state) {
    return state.sync.progress
  },
  syncDate (state) {
    return state.sync.date
  },
  all (state) {
    return state.passes
  },
  count (state) {
    return state.passes.length
  },
  allowedOnline (state) {
    return state.passes.filter(pass => pass.allowInternet)
  }
}

export const actions = {
  async sync ({ commit, state, rootState, rootGetters }, { force = false, change = false } = {}) {
    const guid = rootState.auth.active
    const info = rootGetters['auth/info']
    const features = info?.features

    // Check feature
    if (features && !features.includes('passes')) {
      return
    }

    // Check permission
    if (this.$grants && !this.$grants.all({ pass: ['view'] })) {
      console.log('no pass permissions')
      return
    }

    if (!state.hydrated || change) {
      const passes = await localforage.getItem(guid + '.passes.passes')
      const sync = await localforage.getItem(guid + '.passes.sync')

      if (passes) {
        commit('updatePasses', passes)
      } else {
        commit('updatePasses', [])
      }

      if (sync) {
        commit('setSync', sync)
      } else {
        commit('setSync', { date: null, progress: null, running: false })
      }

      commit('setHydrated', true)
    }

    const date = new Date()

    commit('setSync', { running: true, progress: 0 })

    const sinceDate = (force) ? null : state.sync.date

    const existing = {}
    if (!force) {
      for (let i = 0; i < state.passes.length; ++i) {
        const pass = state.passes[i]
        existing[pass.idPass] = pass
      }
    }

    const errors = []

    try {
      await API.Pass.listAll(sinceDate, (page, pageCount, list) => {
        if (list.items) {
          for (let i = 0; i < list.items.length; ++i) {
            const pass = list.items[i]
            existing[pass.idPass] = pass
          }
        }

        if (list.deleted) {
          for (let i = 0; i < list.deleted.length; ++i) {
            const id = list.deleted[i]
            delete existing[id]
          }
        }

        commit('setSync', { running: true, progress: (page / pageCount) })
      })
    } catch (e) {
      if (e?.response?.status === 304) {
        console.log('Pass data is up to date')
      } else {
        errors.push(e)
      }
    } finally {
      commit('updatePasses', Object.values(existing))

      if (errors.length) {
        commit('setSync', { running: false, progress: null, date: null, error: true })
      } else {
        commit('setSync', { running: false, progress: null, date })
      }

      localforage.setItem(guid + '.passes.passes', state.passes)
      localforage.setItem(guid + '.passes.sync', state.sync)
    }
  }
}
